import { SnackbarService } from '../snackbar.service';
import { validateRequired } from './validation.util';

/**
 * Bundles the date-range pair used by every report's filter strip.
 * Replaces the duplicated `dateRangeStart/dateRangeEnd/startDate/endDate`
 * fields and `dateRangeChange()` method that lived on each component.
 *
 * Usage in a component:
 *
 *   range = new DateRange();
 *   ...
 *   <input ... (dateChange)="range.set(start, end)">
 *   ...
 *   if (!this.range.validate(this.snackbar)) return;
 *   const payload = { start_date: this.range.start, end_date: this.range.end };
 */
export class DateRange {
  start: string = '';
  end: string = '';

  /** Bound to (dateChange) on the `<input matStartDate>` / `<input matEndDate>`. */
  set(startEl: HTMLInputElement, endEl: HTMLInputElement): void {
    this.start = startEl.value;
    this.end = endEl.value;
  }

  /** Returns true when both dates are populated; otherwise warns once. */
  validate(snackbar: SnackbarService): boolean {
    return validateRequired(
      [
        { value: this.start, label: 'date range' },
        { value: this.end, label: 'date range' },
      ],
      snackbar,
    );
  }

  reset(): void {
    this.start = '';
    this.end = '';
  }
}
